import { FabricationJobState, QuoteItemFabricationStatus } from '../../api/fabrication-job-api';
import { html } from 'lit';
import { LangFabricationJobDetailView } from '../../../localization/scripts/fabrication-jobs/views/fabrication-job-detail-view-lang';

export function getFabricationJobStateLabel(state: FabricationJobState): string {
  switch (state) {
    case FabricationJobState.Draft:
      return LangFabricationJobDetailView.stateDraft();
    case FabricationJobState.Planned:
      return LangFabricationJobDetailView.statePlanned();
    case FabricationJobState.AwaitingOrder:
      return LangFabricationJobDetailView.stateAwaitingOrder();
    case FabricationJobState.ReadyForProduction:
      return LangFabricationJobDetailView.stateReadyForProduction();
    case FabricationJobState.InProduction:
      return LangFabricationJobDetailView.stateInProduction();
    case FabricationJobState.Completed:
      return LangFabricationJobDetailView.stateCompleted();
    default:
      return '';
  }
}

export function getFabricationJobStateCssName(state: FabricationJobState): string {
  switch (state) {
    case FabricationJobState.Draft:
      return 'draft';
    case FabricationJobState.Planned:
      return 'planned';
    case FabricationJobState.AwaitingOrder:
      return 'awaitingorder';
    case FabricationJobState.ReadyForProduction:
      return 'readyforproduction';
    case FabricationJobState.InProduction:
      return 'inproduction';
    case FabricationJobState.Completed:
      return 'completed';
    default:
      return '';
  }
}

/**
 * Font Awesome name for a job state, so a badge can carry the same glyph wherever the state is
 * shown. Kept beside the label and css-name lookups: an icon is one more way of naming the state,
 * and the three drifting apart is what makes two surfaces disagree.
 */
export function getFabricationJobStateIcon(state: FabricationJobState): string {
  switch (state) {
    case FabricationJobState.Draft:
      return 'fas-pen';
    case FabricationJobState.Planned:
      return 'fas-calendar-check';
    case FabricationJobState.AwaitingOrder:
      return 'fas-cart-shopping';
    case FabricationJobState.ReadyForProduction:
      return 'fas-play';
    case FabricationJobState.InProduction:
      return 'fas-gears';
    case FabricationJobState.Completed:
      return 'fas-circle-check';
    default:
      return '';
  }
}

/** Font Awesome name for a quote item's own fabrication status. */
export function getQuoteItemFabricationStatusIcon(status: QuoteItemFabricationStatus): string {
  switch (status) {
    case QuoteItemFabricationStatus.ReadyForFabrication:
      return 'fas-clipboard-list';
    case QuoteItemFabricationStatus.AssignedToFabricationJob:
      return 'fas-link';
    case QuoteItemFabricationStatus.InProduction:
      return 'fas-gears';
    case QuoteItemFabricationStatus.ReadyForDelivery:
      return 'fas-boxes-stacked';
    case QuoteItemFabricationStatus.Delivered:
      return 'fas-circle-check';
    default:
      return '';
  }
}

export const getFabricationJobStatus = (state: FabricationJobState, asBadge = false) => {
  if (!asBadge) return html`${getFabricationJobStateLabel(state)}`;

  const value = getFabricationJobStateCssName(state);
  const text = getFabricationJobStateLabel(state);

  return html`<span class="badge badge-${value}"
    ><webmodule-icon library="fa" name=${getFabricationJobStateIcon(state)}></webmodule-icon> ${text}</span
  >`;
};
